import { ContentTopBar } from 'components'
import { usePaginationParams } from 'hooks';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';

import { UploadDetailsTable } from '../component/upload-deatils-list-tabel/upload-details-list-UploadDetails-table';
import { useGetUploadDetails } from '../use-cases/get-upload-details';

const UploadListDetails = () => {
    const location = useLocation();
    const { id } = useParams();
    const params1 = new URLSearchParams(location.search);
    const [searchParams] = useSearchParams()
    const eventId = params1.get("eventId");
    ;
    const origin = searchParams.get("origin");
    const originType =
        origin === "BulkUpload" ? "bulkupload" : "groupregistration";
    const { params, updateParams } =
        usePaginationParams<any>({
            id: id,
            page: 1,
            eventId: eventId,
            size: 10,
        });

    const { data, isFetching, refetch } = useGetUploadDetails(params, originType, { retry: false });

    const updatedTitle: string | undefined = location.pathname.includes("/group-registration-List")
        ? "Group Registration"
        : "Bulk Upload"


    return (
        <>

            <ContentTopBar
                title={`${updatedTitle} Participant List`}
            />


            <UploadDetailsTable
                data={data}
                isLoading={isFetching}
                tableParams={params}
                refetch={refetch}
                updateParams={updateParams}
                id={id}

            />
        </>
    )
}

export default UploadListDetails
